import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckLargeCircleIcon from '../../../icons/check-large-circle.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Tooltip from '@material-ui/core/Tooltip';
import './ButtonInput.scss';
import InfoIcon from '@material-ui/icons/Info';
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  activeBorder: {    
    borderColor: alpha(theme.palette.primary.main, .5),
  },
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
}));

export default function ButtonInput(props) {

  const classes = useStyles();
  
  return (
    <Button
      variant={props.value ? 'outlined' : 'contained'}
      className={`shadow button-card-input ${props.value ?`'active ${classes.activeBorder}` : 'inactive'} ${props.mobileWide ? 'wide-sm' : ''} ${props.noMargin ? '' : 'mt-4'}`}
      onClick={props.onClick}
      aria-pressed={props.value}
      aria-labelledby={props.title}
    >
      <span className='healthQueSpan'>
        <div className="d-flex justify-content-center">
          <div className={`icon-container ${classes.lightBackground}`}>
            <SvgIcon fontSize="large" color="primary" component={props.icon} className={props.infoText ? 'mr-0' : ''} />
          </div>
        </div>
        {props.infoText && (
          <Tooltip title={props.infoText} className="float-right m-0">
            <InfoIcon color="action"></InfoIcon>
          </Tooltip>
        )}
        <h2 className="title">{props.title}</h2>
        {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
        {props.value ? (
          <SvgIcon component={CheckLargeCircleIcon} color="primary" name={props.productName} className="check" />
        ) : (
          <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck" />
        )}
      </span>
    </Button>
  );
}

ButtonInput.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  mobileWide: PropTypes.bool,
  noMargin: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/ButtonInput.js